module.exports = __webpack_public_path__ + "img/placeholder.94ae8628.png";